function searchFocusBlur() {
    var el = document.querySelector('.search-text')
    el.onfocus = () => {el.parentElement.parentElement.classList.add('focus')}
    el.onblur  = () => {el.parentElement.parentElement.classList.remove('focus')}
}
window.addEventListener('load', searchFocusBlur)

function chooseOption() {
    // console.log(this)
    var item 		= this,
        optionName 	= item.innerHTML,
        option 		= item.dataset.value,
        current 	= item.parentElement.previousElementSibling,
        others 		= item.parentElement.querySelectorAll('.selected')
    if (others) {
        for (let i = 0; i < others.length; i++) {
            others[i].classList.remove('selected')
        }
    }
    current.innerHTML = optionName
    item.classList.add('selected')
    closeSelect()
    // отобразить новый список новостей
    if (jsNews) renderNewsList(jsNews.filter(item => item.RUBRICCODE.indexOf(option) > -1))
}

function renderNewsList(ar) {
    if (ar) {
        var to = document.querySelector('.newslist'),
            list = '<div class="top-news flex">'
        for (let i = 0; i < ar.length; i++) {
            if (i < 2) {
                list += '<a href="' + ar[i]['CODE'] + '/" class="half card flex column">'
                list += '<div class="img"><img src="' + ar[i]['ANONSIMG'] + '" alt="' + ar[i]['NAME'] + '"></div>'
                list += '<div class="anonce flex column">'
                list += '<div class="type Semibold">' + ar[i]['RUBRICNAME'] +'</div>'
                list += '<div class="title Semibold"><span>' + ar[i]['NAME'] +'</span></div>'
                list += '<div class="date">' + ar[i]['DATE'] +'</div>'
                list += '</div></a>'
            }
        }
        list += '</div>'
        if(ar.length > 2) {
            list += '<div class="flex threecol">'
            for (let i = 2; i < ar.length; i++) {
                list += '<a href="' + ar[i]['CODE'] + '/" class="card flex column">'
                list += '<div class="img"><img src="' + ar[i]['ANONSIMG'] + '" alt="' + ar[i]['NAME'] + '"></div>'
                list += '<div class="anonce flex column">'
                list += '<div class="type Semibold">' + ar[i]['RUBRICNAME'] +'</div>'
                list += '<div class="title Semibold"><span>' + ar[i]['NAME'] +'</span></div>'
                list += '<div class="date">' + ar[i]['DATE'] +'</div>'
                list += '</div></a>'
            }
            list += '</div>'
        }
        to.innerHTML = list
    }
}